"use client";

import { ChevronRight } from "lucide-react";

/** 회차 picker 항목의 최소 shape. `ExamSession`도 구조적으로 할당 가능. */
export interface SessionListItem {
  id: string;
  displayName: string;
  isActive: boolean;
}

/**
 * 지난 회차 목록 picker (JCG-1859 / JCG-3283).
 *
 * `PreviousSessionDialog`(회차별 라이브 조회)와 "지난 회차 보기" 버튼(대시보드 스냅샷 이동)이 공유한다.
 * `onSelect`는 전달받은 항목 원본을 그대로 돌려주므로(제네릭), 호출부는 `ExamSession` 등 확장 타입을
 * 넘겨도 그 타입 그대로 콜백에서 받는다.
 */
export function SessionList<T extends SessionListItem>({
  sessions,
  onSelect,
}: {
  sessions: T[];
  onSelect: (session: T) => void;
}) {
  if (sessions.length === 0) {
    return (
      <div className="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
        조회 가능한 이전 회차가 없습니다.
      </div>
    );
  }
  return (
    <div className="space-y-2">
      {sessions.map((session) => (
        <button
          key={session.id}
          type="button"
          onClick={() => onSelect(session)}
          className="flex w-full items-center justify-between rounded-md border border-gray-200 dark:border-neutral-700 px-3 py-2 text-left transition-colors hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 dark:hover:bg-neutral-800"
        >
          <div>
            <div className="text-sm font-medium">{session.displayName}</div>
            <div className="text-xs text-gray-500 dark:text-gray-400">
              {session.isActive ? "활성 회차" : "이전 회차"}
            </div>
          </div>
          <ChevronRight className="h-4 w-4 shrink-0 text-gray-400" aria-hidden />
        </button>
      ))}
    </div>
  );
}
